import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Container } from '../styles/components';
import Logo from './Logo';
import CTAButton from './CTAButton';
import Modal from './Modal';
import ConvertkitFormComponent from './ConvertKitForm';

const HeaderWrapper = styled.header`
  padding: 20px 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
  background-color: ${props => props.$isScrolled ? props.theme.colors.background : 'transparent'};
  box-shadow: ${props => props.$isScrolled ? '0 2px 8px rgba(0, 0, 0, 0.1)' : 'none'};
  backdrop-filter: ${props => props.$isScrolled ? 'blur(8px)' : 'none'};
`;

const HeaderContainer = styled(Container)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: ${props => props.theme.spacing.maxWidth};
  margin: 0 auto;
  padding: 0;
`;

const LogoLink = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
`;

const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.md};
`;

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    let observer;

    const setupObserver = () => {
      const tagElement = document.querySelector('.hero-tag');
      
      if (tagElement) {
        observer = new IntersectionObserver(
          ([entry]) => {
            setIsScrolled(!entry.isIntersecting);
          },
          {
            threshold: 0,
            rootMargin: '-80px 0px 0px 0px'
          }
        );
        
        observer.observe(tagElement);
      } else {
        // If we can't find the tag, fall back to observing the hero section
        const heroSection = document.querySelector('#hero');
        if (heroSection) {
          observer = new IntersectionObserver(
            ([entry]) => {
              setIsScrolled(!entry.isIntersecting);
            },
            {
              threshold: 0,
              rootMargin: '-80px 0px 0px 0px'
            }
          );
          observer.observe(heroSection);
        }
      }
    };

    // Wait a brief moment for React to finish rendering
    setTimeout(setupObserver, 0);

    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, []);

  useEffect(() => {
  }, [isScrolled]);

  const handleCTAClick = () => {
    setIsModalOpen(true);
  };


  return (
    <>
      <HeaderWrapper $isScrolled={isScrolled}>
        <HeaderContainer>
          <LogoLink href="/">
            <Logo size="40px"  />
          </LogoLink>
          <Nav>
            <CTAButton 
              onClick={handleCTAClick}
              type="button"
            >
              Join the waitlist and save $300
            </CTAButton>
            <CTAButton 
              secondary 
              as="a" 
              href="https://app.moogul.ai"
              dark={isScrolled}
            >
              Log in
            </CTAButton>
          </Nav>
        </HeaderContainer>
      </HeaderWrapper>

      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <ConvertkitFormComponent />
      </Modal>
    </>
  );
};

export default Header; 